// extracted by mini-css-extract-plugin
module.exports = {"page-container":"AfterLoginLayout_page-container__P19Pw","main":"AfterLoginLayout_main__1VkHq","page-content":"AfterLoginLayout_page-content__1L3SK"};